<template>
  <router-view></router-view>
</template>

<script>
export default {
  mounted() {
    this.Report('view', 'StudioPage', { v3: 'creatorHome' });
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
}
</style>
